/**
 * Catalogue exhaustif des droits.
 *
 * Convention de nommage : `DOMAINE_ACTION[_PORTEE]`
 *  - `_OWN`  : l'action ne porte que sur les ressources de l'utilisateur courant
 *  - `_ALL`  : l'action porte sur toutes les ressources
 *
 * Ces chaînes sont l'unique langage commun entre l'API (guard `@Granted`) et le
 * front (`isGranted()` / `meta.granted` des routes). Ne jamais tester un rôle
 * directement dans le code métier : toujours un droit.
 */
export enum Right {
	// --- Compte / profil -----------------------------------------------------
	ACCOUNT_READ = 'ACCOUNT_READ',
	ACCOUNT_EDIT = 'ACCOUNT_EDIT',
	ACCOUNT_DELETE = 'ACCOUNT_DELETE',

	// --- Courses côté client -------------------------------------------------
	RIDE_CREATE = 'RIDE_CREATE',
	RIDE_ESTIMATE = 'RIDE_ESTIMATE',
	RIDE_READ_OWN = 'RIDE_READ_OWN',
	RIDE_CANCEL_OWN = 'RIDE_CANCEL_OWN',
	RIDE_CLAIM = 'RIDE_CLAIM',

	// --- Courses côté exploitation ------------------------------------------
	RIDE_READ_ALL = 'RIDE_READ_ALL',
	RIDE_CANCEL_ALL = 'RIDE_CANCEL_ALL',
	RIDE_ASSIGN = 'RIDE_ASSIGN',
	RIDE_EXPORT = 'RIDE_EXPORT',

	// --- Chauffeur -----------------------------------------------------------
	DRIVER_MODE = 'DRIVER_MODE',
	DRIVER_SELF_READ = 'DRIVER_SELF_READ',
	DRIVER_SELF_EDIT = 'DRIVER_SELF_EDIT',
	DRIVER_STATUS_SET = 'DRIVER_STATUS_SET',
	DRIVER_POSITION_SET = 'DRIVER_POSITION_SET',
	DRIVER_OFFER_READ = 'DRIVER_OFFER_READ',
	DRIVER_OFFER_ANSWER = 'DRIVER_OFFER_ANSWER',
	DRIVER_RIDE_PROGRESS = 'DRIVER_RIDE_PROGRESS',

	// --- Chauffeurs / véhicules (administration) ----------------------------
	DRIVER_READ_ALL = 'DRIVER_READ_ALL',
	DRIVER_EDIT_ALL = 'DRIVER_EDIT_ALL',
	DRIVER_CREATE = 'DRIVER_CREATE',
	VEHICLE_READ_ALL = 'VEHICLE_READ_ALL',
	VEHICLE_EDIT_ALL = 'VEHICLE_EDIT_ALL',

	// --- Lieux (hôtels, aéroports, gares, points d'intérêt) -----------------
	PLACE_READ = 'PLACE_READ',
	PLACE_EDIT = 'PLACE_EDIT',

	// --- Bornes --------------------------------------------------------------
	KIOSK_SESSION = 'KIOSK_SESSION',
	KIOSK_READ_ALL = 'KIOSK_READ_ALL',
	KIOSK_EDIT_ALL = 'KIOSK_EDIT_ALL',

	// --- Utilisateurs / sécurité --------------------------------------------
	USER_READ_ALL = 'USER_READ_ALL',
	USER_EDIT_ALL = 'USER_EDIT_ALL',
	USER_DELETE_ALL = 'USER_DELETE_ALL',
	USER_LOGIN_AS = 'USER_LOGIN_AS',
	RIGHTS_READ = 'RIGHTS_READ',

	// --- Paramètres d'exploitation -------------------------------------------
	SETTINGS_READ = 'SETTINGS_READ',
	SETTINGS_EDIT = 'SETTINGS_EDIT',

	// --- Back-office ---------------------------------------------------------
	BO_ACCESS = 'BO_ACCESS',
	BO_LIVE_MAP = 'BO_LIVE_MAP',
	STATS_READ = 'STATS_READ',
}

export const ALL_RIGHTS: Right[] = Object.values(Right);

export type RightLike = Right | `${Right}` | string;
